module.exports = __webpack_public_path__ + "media/images/methodist_channels_landing-4b10122e78f62d899156a1fee49bb871.png";